module.exports = __webpack_public_path__ + "img/AI-WRITER-02.c76ff3ff.png";